<template>
  <v-card min-height="100vh" color="grey lighten-3">
    <BaseToolbar
      :title="$t(`organization.users.${organizationDrawerUserState.type}`)"
      type-title="icon"
      icon="edit"
      :button-save="true"
      @close="closeDrawerUser"
      @save="save"
    />
    <v-card-text style="overflow-y: auto;height: calc(100vh - 64px)">
      <v-container>
        <v-row justify="center">
          <v-col cols="12" md="10">
            <v-card
              class="afrus-d-rounded-card"
              v-if="!emailSearch && organizationDrawerUserState.type === 'new'"
            >
              <v-card-title class="title">
                {{ $t('organization.users.title') }}
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-row dense>
                  <v-col cols="12">
                    <v-text-field
                      v-model="localUser.email"
                      v-validate="'required|email'"
                      data-vv-name="email"
                      required
                      dense
                      :readonly="userFound"
                      :error-messages="errors.collect('email')"
                      :label="$t('profile.profile.email')"
                    ></v-text-field>
                  </v-col>
                  <template v-if="userFound">
                    <v-col cols="6">
                      <v-text-field
                        v-model="localUser.first_name"
                        dense
                        readonly
                        :label="$t('profile.profile.people.firstname')"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="6">
                      <v-text-field
                        v-model="localUser.last_name"
                        dense
                        readonly
                        :label="$t('profile.profile.people.lastname')"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="6">
                      <v-text-field
                        v-model="localUser.gender"
                        dense
                        readonly
                        :label="$t('profile.profile.gender')"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="6">
                      <!-- <v-text-field
                        v-model="localUser.rol"
                        dense
                        :label="$t('profile.profile.role')"
                      ></v-text-field>
                        readonly -->
                      <v-select
                        v-model="localUser.role_id"
                        dense
                        v-validate="'required'"
                        :items="roles"
                        item-text="name"
                        item-value="id"
                        :label="$t('profile.profile.role')"
                        :data-vv-name="$t('profile.profile.role')"
                        :error-messages="
                          errors.collect($t('profile.profile.role'))
                        "
                      />
                    </v-col>
                    <v-col cols="6">
                      <v-text-field
                        v-model="localUser.phone"
                        dense
                        readonly
                        :label="$t('profile.profile.phone')"
                      ></v-text-field>
                    </v-col>
                  </template>
                </v-row>
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions class="pa-4">
                <v-spacer></v-spacer>
                <v-btn color="primary" v-if="userFound" @click="cleanData()">
                  {{ $t('general.cancel') }}
                </v-btn>
                <v-btn
                  color="primary"
                  v-if="userFound"
                  @click="addToOrganization()"
                >
                  {{ $t('general.add') }}
                </v-btn>
                <v-btn
                  color="primary"
                  v-if="!userFound"
                  @click="validateEmail()"
                >
                  {{ $t('general.search') }}
                </v-btn>
              </v-card-actions>
            </v-card>

            <v-card class="afrus-d-rounded-card" v-else>
              <v-card-title class="title">
                {{ $t('organization.users.title') }}
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-row dense>
                  <v-col cols="2">
                    <v-select
                      v-model="localUser.treatment"
                      dense
                      v-validate="'required'"
                      :data-vv-name="
                        $t('profile.profile.people.treatment.text')
                      "
                      :items="[
                        {
                          text: $t('profile.profile.people.treatment.mrs'),
                          value: 'mrs'
                        },
                        {
                          text: $t('profile.profile.people.treatment.mr'),
                          value: 'mr'
                        }
                      ]"
                      :label="$t('profile.profile.people.treatment.text')"
                      required
                      :error-messages="
                        errors.collect(
                          $t('profile.profile.people.treatment.text')
                        )
                      "
                    />
                  </v-col>
                  <v-col cols="5">
                    <v-text-field
                      v-model="localUser.first_name"
                      dense
                      v-validate="'required'"
                      data-vv-name="first_name"
                      required
                      :error-messages="errors.collect('first_name')"
                      :label="$t('profile.profile.people.firstname')"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="5">
                    <v-text-field
                      v-model="localUser.last_name"
                      dense
                      v-validate="'required'"
                      data-vv-name="last_name"
                      required
                      :error-messages="errors.collect('last_name')"
                      :label="$t('profile.profile.people.lastname')"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="6">
                    <v-text-field
                      v-model="localUser.email"
                      dense
                      v-validate="'required|email'"
                      data-vv-name="email"
                      required
                      :error-messages="errors.collect('email')"
                      :label="$t('profile.profile.email')"
                      @input="cleanData()"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="6">
                    <v-text-field
                      v-model="localUser.phone"
                      dense
                      v-validate="{
                        regex: /(([+][(]?[0-9]{1,3}[)]?)|([(]?[0-9]{4}[)]?))\s*[)]?[-\s\.]?[(]?[0-9]{1,3}[)]?([-\s\.]?[0-9]{3})([-\s\.]?[0-9]{3,4})/
                      }"
                      data-vv-name="phone"
                      required
                      :error-messages="errors.collect('phone')"
                      :label="$t('profile.profile.phone')"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="6">
                    <v-select
                      v-model="localUser.gender"
                      dense
                      :items="[
                        {
                          text: this.$t('profile.profile.people.gender.female'),
                          value: 'F'
                        },
                        {
                          text: this.$t('profile.profile.people.gender.male'),
                          value: 'M'
                        }
                      ]"
                      :data-vv-name="$t('profile.profile.gender')"
                      :label="$t('profile.profile.gender')"
                      :error-messages="
                        errors.collect($t('profile.profile.gender'))
                      "
                    />
                  </v-col>
                  <v-col
                    cols="6"
                    v-if="organizationDrawerUserState.type === 'new'"
                  >
                    <v-text-field
                      v-model="localUser.password"
                      dense
                      data-vv-name="password"
                      type="password"
                      :error-messages="errors.collect('password')"
                      :label="$t('login.password')"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="6">
                    <v-select
                      v-model="localUser.language_code"
                      dense
                      v-validate="'required'"
                      :items="languages"
                      item-text="name"
                      item-value="code"
                      :error-messages="
                        errors.collect($t('profile.profile.language'))
                      "
                      :label="$t('profile.profile.language')"
                      :data-vv-name="$t('profile.profile.language')"
                      required
                    />
                  </v-col>
                  <v-col cols="6">
                    <v-autocomplete
                      v-model="localUser.time_zone"
                      dense
                      v-validate="'required'"
                      :items="time_zones"
                      :label="$t('profile.profile.timezone')"
                      :error-messages="
                        errors.collect($t('profile.profile.timezone'))
                      "
                      :data-vv-name="$t('profile.profile.timezone')"
                      required
                    />
                  </v-col>
                  <v-col cols="6">
                    <v-select
                      v-model="localUser.role_id"
                      dense
                      v-validate="'required'"
                      :items="roles"
                      item-text="name"
                      item-value="id"
                      :label="$t('profile.profile.role')"
                      :data-vv-name="$t('profile.profile.role')"
                      :error-messages="
                        errors.collect($t('profile.profile.role'))
                      "
                    />
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'
import BaseToolbar from '@/components/BaseToolbar'
import moment from 'moment-timezone'

export default {
  components: {
    BaseToolbar
  },
  created() {
    this.getRole()
  },
  watch: {
    orgUser(newVal, oldVal) {
      if (newVal.id) {
        let user = JSON.parse(JSON.stringify(newVal))

        const getPersonValue = (key, defaultValue) => {
          return user && user.person && user.person[key]
            ? user.person[key]
            : defaultValue
        }

        this.localUser.id = user.id
        this.localUser.email = user.email
        this.localUser.role_id = user.pivot.role_id
        this.localUser.phone = getPersonValue('phone', '')
        this.localUser.gender = getPersonValue('gender', '')
        this.localUser.last_name = getPersonValue('last_name', '')
        this.localUser.time_zone = getPersonValue('time_zone', '')
        this.localUser.first_name = getPersonValue('first_name', '')
        this.localUser.language_code = getPersonValue('language_code', '')
        this.localUser.treatment =
          user && user.person && user.person.treatment === 1 ? 'mrs' : 'mr'
      }
    }
  },
  data() {
    return {
      time_zones: moment.tz.names(),
      emailSearch: false,
      userFound: false,
      localUser: {
        id: null,
        treatment: '',
        first_name: '',
        last_name: '',
        email: '',
        phone: '',
        password: '',
        language_code: '',
        gender: '',
        time_zone: '',
        role_id: null
      },
      roles: []
    }
  },
  methods: {
    ...mapActions({
      getUserByEmail: 'organization/getUserByEmail',
      addUserToOrganization: 'organization/addUserToOrganization',
      createOrganizationUser: 'organization/createOrganizationUser',
      updateOrganizationUser: 'organization/updateOrganizationUser',
      getRoles: 'roles/getRoles'
    }),
    ...mapMutations({
      organizationDrawerUser: 'organization/organizationDrawerUser',
      changeOrganizationUser: 'organization/changeOrganizationUser'
    }),
    cleanData() {
      this.localUser = {
        id: null,
        treatment: '',
        first_name: '',
        last_name: '',
        email: '',
        phone: '',
        password: '',
        language_code: '',
        gender: '',
        time_zone: '',
        role_id: null
      }
      this.emailSearch = false
      this.userFound = false
    },
    getRole() {
      this.getRoles({
        limit: 'all',
        sort: 'id:asc',
        filter: { is_admin: false }
      }).then(res => {
        this.roles = res
      })
    },
    closeDrawerUser() {
      this.cleanData()
      this.organizationDrawerUser({ type: '', value: false })
      this.changeOrganizationUser({})
      this.$nextTick(() => {
        this.$validator.reset()
      })
    },
    async validateEmail() {
      try {
        const email = this.localUser.email
        const res = await this.getUserByEmail({ email })
        if (res.user) {
          this.userFound = true
          this.localUser = {
            id: res.user.id,
            treatment: res.user.person.treatment,
            first_name: res.user.person.first_name,
            last_name: res.user.person.last_name,
            email: res.user.email,
            phone: res.user.person.phone,
            language_code: res.user.person.language_code,
            gender: res.user.person.gender,
            time_zone: res.user.person.time_zone,
            role_id: res.user.role_id || null
          }
        } else {
          this.emailSearch = true
        }
      } catch (err) {
        console.log(err)
      }
    },
    async addToOrganization() {
      const body = {
        user_id: this.localUser.id,
        organizations_ids: [this.organization.id],
        role_id: this.localUser.role_id
      }
      try {
        await this.addUserToOrganization(body)
      } catch (error) {
        console.log(err)
      }
    },
    async save() {
      const {
        email,
        phone,
        gender,
        role_id,
        password,
        last_name,
        treatment,
        time_zone,
        first_name,
        language_code
      } = this.localUser

      const isValid = await this.$validator.validateAll()

      if (!isValid) return

      let data = {
        email,
        phone,
        gender,
        role_id,
        password,
        last_name,
        time_zone,
        first_name,
        language_code,
        password_confirmation: password,
        treatment: treatment === 'mrs' ? 1 : 2
      }

      const isUpdate = !!this.localUser.id
      const action = isUpdate
        ? this.updateOrganizationUser
        : this.createOrganizationUser
      const successMessage = isUpdate
        ? 'organization.users.success_update'
        : 'organization.users.success'
      const errorMessage = isUpdate
        ? 'organization.users.error_update'
        : 'organization.users.error'

      try {
        await action({
          id: this.organization.id,
          body: data,
          ...(isUpdate && { uid: this.localUser.id })
        })
        this.$noty.success(this.$t(successMessage))
      } catch (error) {
        this.$noty.error(`${this.$t(errorMessage)}: ${error.message}`)
      } finally {
        this.closeDrawerUser()
      }
    }
  },
  computed: {
    ...mapState({
      organization: ({ organization: { organization } }) => organization,
      orgUser: ({ organization: { orgUser } }) => orgUser,
      organizationDrawerUserState: ({
        organization: { organizationDrawerUser }
      }) => organizationDrawerUser,
      languages: ({ auth: { locales } }) => locales
    })
  }
}
</script>

<style></style>
